export const createDefaultFocalPoint = (width, height) => {
  return {
    leftPixel: Math.round(width / 2),
    topPixel: Math.round(height / 2),
  };
};

export const getCloudinaryImageUrl = (imageDomain, image, format = 'jpg') => {
  const bothHeightAndWidth = image?.width > 0 && image?.height > 0;
  const x = Math.round(image?.focalPoint?.leftPixel);
  const y = Math.round(image?.focalPoint?.topPixel);
  const hasFocalPoint = x && y;

  // Set crop
  let crop = '';
  if (bothHeightAndWidth) {
    crop = `c_fill,${hasFocalPoint ? `g_xy_center,x_${x},y_${y},` : 'g_auto,'}`;
  } else {
    crop = 'c_scale,';
  }

  // if aspect ratio
  let fixedRatio;
  if (image.ratio) {
    const { a = 2, b = 3, length = 500 } = image.ratio;
    const ab = `${a}:${b}`;
    const ba = `${b}:${a}`;
    fixedRatio = `if_ar_lt_1.0/c_fill,g_auto,h_${length},ar_${ab}/if_else/c_fill,g_auto,w_${length},ar_${ba}/if_end/`;
  }

  const shape =
    fixedRatio ||
    `${crop}${image?.width ? `w_${image?.width},` : ''}${
      image?.height ? `h_${image?.height},` : ''
    }`;

  // Set quality
  const quality = image?.quality ? `q_${image?.quality}` : 'q_auto';

  // Set image url
  const url = image?.relativeSrc || image?.url;

  return `${imageDomain}/image/upload/${shape}f_${format},${quality}${url}`;
};

const getCloudinaryImageSource = (imageDomain, image, type, media) => {
  return {
    media,
    srcSet: getCloudinaryImageUrl(imageDomain, image, type),
    type: `image/${type}`,
  };
};

export const getCloudinaryImageSources = (imageDomain, image, mediaQuery) => [
  getCloudinaryImageSource(imageDomain, image, 'avif', mediaQuery),
  getCloudinaryImageSource(imageDomain, image, 'jp2', mediaQuery),
  getCloudinaryImageSource(imageDomain, image, 'webp', mediaQuery),
  getCloudinaryImageSource(imageDomain, image, 'jpg', mediaQuery),
];